// extracted by mini-css-extract-plugin
export default {"IterationRowSkeletonLabel":"iteration-row-skeleton-module__IterationRowSkeletonLabel--ouf7G"};